import { DateTimeInput, Input, Seperator } from './styles'

DateTimeInput.Input = Input
DateTimeInput.Seperator = Seperator

export default DateTimeInput
